import { createAction } from 'redux-actions';
import {
  GET_REFERENCE_DATA_REQUEST,
  GET_REFERENCE_DATA_SUCCESS,
  GET_REFERENCE_DATA_FAILURE,
  CLEAR_REFERENCE_DATA,
} from './constants';

export const getReferenceData = createAction(GET_REFERENCE_DATA_REQUEST);
export const getReferenceDataSuccess = createAction(GET_REFERENCE_DATA_SUCCESS);
export const getReferenceDataFailure = createAction(GET_REFERENCE_DATA_FAILURE);

export const clearReferenceData = createAction(CLEAR_REFERENCE_DATA);
